import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/trade')({
  component: Outlet,
  beforeLoad: ({ location }) => {
    if (location.pathname === '/trade' || location.pathname === '/trade/') {
      throw redirect({
        to: '/trade/$marketSymbol',
        params: { marketSymbol: 'BTC' },
        replace: true,
      });
    }
  },
});
